
// const isLocalhost = Boolean(
//     window.location.hostname === 'localhost' ||
//     window.location.hostname === '[::1]' ||
//     /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/.test(window.location.hostname)
// );

// export function register(config) {
//     if ('serviceWorker' in navigator) {
//         window.addEventListener('load', () => {
//             const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

//             if (isLocalhost) {
//                 // Running on localhost — helpful for testing.
//                 checkValidServiceWorker(swUrl, config);
//                 navigator.serviceWorker.ready.then(() => {
//                     // console.log('🛠️ Service Worker is active in development mode');
//                 });
//             } else {
//                 // In production
//                 registerValidSW(swUrl, config);
//             }
//         });
//     }
// }

// function registerValidSW(swUrl, config) {
//     navigator.serviceWorker
//         .register(swUrl)
//         .then(registration => {
//             // console.log('✅ Service Worker registered:', registration);

//             registration.onupdatefound = () => {
//                 const installingWorker = registration.installing;
//                 if (installingWorker == null) return;

//                 installingWorker.onstatechange = () => {
//                     if (installingWorker.state === 'installed') {
//                         if (navigator.serviceWorker.controller) {
//                             console.log('🔁 New content available, will be used on next reload');
//                             if (config && config.onUpdate) config.onUpdate(registration);
//                         } else {
//                             console.log('✅ Content cached for offline use');
//                             if (config && config.onSuccess) config.onSuccess(registration);
//                         }
//                     }
//                 };
//             };
//         })
//         .catch(error => {
//             console.error('❌ Error registering Service Worker:', error);
//         });
// }

// function checkValidServiceWorker(swUrl, config) {
//     // Validate SW exists and is correct JS
//     fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
//         .then(response => {
//             const contentType = response.headers.get('content-type');
//             if (
//                 response.status === 404 ||
//                 (contentType != null && contentType.indexOf('javascript') === -1)
//             ) {
//                 // No service worker found
//                 navigator.serviceWorker.ready.then(registration => {
//                     registration.unregister().then(() => {
//                         window.location.reload();
//                     });
//                 });
//             } else {
//                 // Valid service worker
//                 registerValidSW(swUrl, config);
//             }
//         })
//         .catch(() => {
//             console.log('❌ No internet connection. App running in offline mode.');
//         });
// }

// export function unregister() {
//     if ('serviceWorker' in navigator) {
//         navigator.serviceWorker.ready
//             .then(registration => registration.unregister())
//             .catch(error => console.error(error.message));
//     }
// }

const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/.test(window.location.hostname)
);

export function register(config) {
    if ("serviceWorker" in navigator) {
        window.addEventListener("load", () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            if (isLocalhost) {
                // ✅ Dev Mode: Validate and auto-update
                checkValidServiceWorker(swUrl, config);
                navigator.serviceWorker.ready
                    .then((registration) => {
                        console.log("🛠️ Dev mode: service worker ready");
                        registration.update(); // 🔁 Force check for updated SW
                    })
                    .catch((err) => console.warn("⚠️ Service worker ready error:", err));
            } else {
                // ✅ Production
                registerValidSW(swUrl, config);
            }
        });
    }
}



function registerValidSW(swUrl, config) {
    navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
            console.log("✅ Service Worker registered");

            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (!installingWorker) return;

                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            console.log("🔁 New content available (next reload)");
                            if (config?.onUpdate) config.onUpdate(registration);
                        } else {
                            console.log("✅ Content cached for offline use");
                            if (config?.onSuccess) config.onSuccess(registration);
                        }
                    }
                };
            };
        })
        .catch((error) => {
            console.error("❌ Error during service worker registration:", error);
        });
}

function checkValidServiceWorker(swUrl, config) {
    fetch(swUrl, { headers: { "Service-Worker": "script" } })
        .then((response) => {
            const contentType = response.headers.get("content-type");
            if (
                response.status === 404 ||
                (contentType && !contentType.includes("javascript"))
            ) {
                // ❌ No SW found or wrong type
                navigator.serviceWorker.ready
                    .then((registration) => {
                        registration.unregister().then(() => {
                            console.warn("♻️ Invalid service worker. Unregistered.");
                            // 👇 Debounced reload to avoid infinite loop
                            setTimeout(() => window.location.reload(), 500);
                        });
                    })
                    .catch((err) => console.warn("SW unregister error", err));
            } else {
                // ✅ Valid SW found
                registerValidSW(swUrl, config);
            }
        })
        .catch(() => {
            console.log("❌ No internet connection. Running offline.");
        });
}

export function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => registration.unregister())
            .catch((error) => console.error("❌ Unregister failed:", error));
    }
}
